(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('NewChecklistSubmissionController', NewChecklistSubmissionController);

  /* ngInject */
  function NewChecklistSubmissionController($state, $stateParams, checklistSubmissionService, checklistFormService, sessionService, Flash) {
    const vm = this;

    vm.checklistForm = {};
    vm.checklistSubmission = {};
    vm.saveChecklistSubmission = saveChecklistSubmission;

    activate();

    function activate() {
      getChecklistForm();
    }

    function getChecklistForm() {
      checklistFormService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => {
        vm.checklistForm = response;
      });
    }

    function saveChecklistSubmission() {
      checklistSubmissionService(sessionService.getAuthToken()).save(vm.checklistSubmission, _response => {
        Flash.create('success', 'Checklist submission was successfully created.');
        $state.go('application.compliance_services.checklist_submissions');
      }, _error => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
      });
    }
  }
})();
